import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CrmProvider } from "@/context/CrmContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Feed from "@/pages/Feed";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Meetings from "@/pages/Meetings";
import Analytics from "@/pages/Analytics";
import Import from "@/pages/Import";
import Team from "@/pages/Team";
import Audit from "@/pages/Audit";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Duplicates from "@/pages/Duplicates";
import Clinic from "@/pages/Clinic";
import ClinicLogin from "@/pages/ClinicLogin";

const Protected = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#0B0F17] text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const MGR = ["ADMIN", "SALES_MANAGER"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.NODE_ENV === "production" ? process.env.PUBLIC_URL : "/"}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/clinic/login" element={<ClinicLogin />} />
          <Route element={<Protected><CrmProvider><Layout /></CrmProvider></Protected>}>
            <Route index element={<Feed />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="import" element={<Protected roles={MGR}><Import /></Protected>} />
            <Route path="team" element={<Protected roles={MGR}><Team /></Protected>} />
            <Route path="audit" element={<Protected roles={["ADMIN"]}><Audit /></Protected>} />
            <Route path="reports" element={<Protected roles={MGR}><Reports /></Protected>} />
            <Route path="duplicates" element={<Protected roles={MGR}><Duplicates /></Protected>} />
            <Route path="settings" element={<Settings />} />
            <Route path="clinic" element={<Protected roles={["ADMIN", "SALES_MANAGER", "CLINIC_STAFF"]}><Clinic /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
